import { SIGNUPDATA_REQUEST, SIGNUPDATA_SUCCESS, SIGNUPDATA_FAILURE } from '../Constants/ActionTypes.js';

export const SignUpDataReducer = (state = { signUpData: [], isLoading: false }, action) => {
  switch (action.type) {
    case SIGNUPDATA_REQUEST:
      return { ...state, isLoading: true };
    case SIGNUPDATA_SUCCESS:
      return { ...state, signUpData: action.payload, isLoading: false };
    case SIGNUPDATA_FAILURE:
      return { ...state, isLoading: false };
    default:
      return state;
  }
};
